import { render } from "./Im3py.vue?vue&type=template&id=4fe65116"
import script from "./Im3py.vue?vue&type=script&lang=js"
export * from "./Im3py.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__